import {apiDelete, API_URL} from '../api'

export const deleteRecommendApi = async (id: string) => {
    return await apiDelete(API_URL, `admin/featured/${id}`, {})
}
